function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_37",
  "data-name": "Path 37",
  d: "M160.006,0C105.507,0,64,106.673,64,160.056a96.006,96.006,0,0,0,192.011,0C256.011,106.673,214.5,0,160.006,0Z",
  transform: "translate(-64)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_38",
  "data-name": "Path 38",
  d: "M170.671,256.014a85.415,85.415,0,0,1-85.339-85.3c0-50.483,38.638-149.394,85.339-149.394s85.338,98.911,85.338,149.394A85.415,85.415,0,0,1,170.671,256.014Z",
  transform: "translate(-74.666 -10.661)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_39",
  "data-name": "Path 39",
  d: "M256,21.323c35.026,0,64,98.911,64,149.394,0,47.031-28.713,85.3-64,85.3a85.416,85.416,0,0,0,85.339-85.3C341.339,120.234,302.7,21.323,256,21.323Z",
  transform: "translate(-159.994 -10.661)",
  fill: "rgba(147,147,147,0.69)",
  opacity: 0.1
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_40",
  "data-name": "Path 40",
  d: "M106.668,170.717c0-50.483,28.978-149.394,64-149.394-46.7,0-85.339,98.911-85.339,149.394a85.416,85.416,0,0,0,85.339,85.3C135.38,256.014,106.668,217.748,106.668,170.717Z",
  transform: "translate(-74.666 -10.661)",
  fill: "rgba(147,147,147,0.69)",
  opacity: 0.2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_41",
  "data-name": "Path 41",
  d: "M160.006,0C105.507,0,64,106.673,64,160.056a96.006,96.006,0,0,0,192.011,0C256.011,106.673,214.5,0,160.006,0Z",
  transform: "translate(-64)",
  fill: "rgba(147,147,147,0.69)"
});

function SvgEgg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "egg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 192.011,
    height: 256.015,
    viewBox: "0 0 192.011 256.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/egg.8cc47e6a.svg";
export { ForwardRef as ReactComponent };